import React, { useEffect, useState } from 'react'
import { css } from '@linaria/core'
import MapMarker from './MapMarker.svg'

const mapCss = css`
  width: 100%;
  height: 120px;
  position: relative;

  & img {
    margin: 16px calc(50% - 16px) 56px calc(50% - 22px);
    position: absolute;
    width: 48px;
    height: 50px;
  }
`

const mapBackground = (place, mapKey) => {
  const lat = place?.location?.latitude || ''
  const lng = place?.location?.longitude || ''
  const zoom = place?.zoom || 13
  const center = `${lat},${lng}`
  const params = `center=${center}&zoom=${zoom}&size=600x120&maptype=roadmap&key=${mapKey}`

  const url = lat && lng ? `https://maps.googleapis.com/maps/api/staticmap?${params}` : ''
  return {
    backgroundImage: `url(${url})`,
    backgroundPosition: 'center',
  }
}
const initialMap = mapBackground()

export default function StaticMap({ standard, mapKey }) {
  const [mapStyle, setMapStyle] = useState(initialMap)

  useEffect(() => setMapStyle(mapBackground(standard?.standard, mapKey)), [standard, mapKey])

  return (
    <a
      href={`https://beta.familysearch.org/research/places/?focusedId=${standard?.standard?.id || ''}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={mapCss} style={mapStyle}>
        <img src={MapMarker} alt="Map Marker" />
      </div>
    </a>
  )
}
